import { Typography } from '@mui/material';
import { InteractiveModal } from 'components/Modals/InteractiveModal/BaseModal';
import OperatorHandler from 'handlers/operator.handler';
import { useTranslation } from 'react-i18next';

export {};

/**
 *
 * The activation modal is a modal that is used to activate an External operator.
 */

interface Props {
  open: boolean;
  operatorId: string;
  isActive: boolean;
  handleAbort: () => void;
}

export const OperatorActivationModal = ({
  open,
  operatorId,
  isActive,
  handleAbort,
}: Props) => {
  const { t } = useTranslation();
  const operatorHandler = new OperatorHandler();
  const title = 'Confirm Operator Reactivation';
  return (
    <InteractiveModal
      initialState={open}
      title={title}
      handleAbort={handleAbort}
      SuccessButtonProps={{
        onClick: async () => {
          await operatorHandler.activationOperator(operatorId, isActive);
          handleAbort();
        },
        disabled: false,
        label: t('reactivate_operator'),
      }}
      ModalContentProps={{
        gridItemProps: {
          lg: 12,
        },
      }}
    >
      <Typography key="blurb-1" variant="medium">
        {t('are_you_sure_you_want_to_reactivate')} {operatorId}?
      </Typography>
      <Typography key="blurb-2" variant="medium"></Typography>
    </InteractiveModal>
  );
};
